import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ImageContainer as CompiledImageContainer } from './imageContainer-compiled';
import { ImageContainer as EmotionImageContainer } from './imageContainer-compiled';
export var ImageContainer = function ImageContainer(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledImageContainer, props) : /*#__PURE__*/React.createElement(EmotionImageContainer, props);
};